export enum ChipType {
    CHIP_1 = 1,
    CHIP_5 = 5,
    CHIP_10 = 10,
    CHIP_25 = 25,
    CHIP_50 = 50,
    CHIP_100 = 100
}